/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import React, {
  useState, useEffect,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import IcomoonReact from 'icomoon-react';
import Select, { components } from 'react-select';
import iconSet from '../../../../shared/images/teambuildr-selection.json';

import {
  updateProgrammedCalendarItem,
  updateSavedWorkoutItem,
  setCombineWithInfo,
  swapProgrammedItemOnChildCalendar,
} from '../../ducks/calendarActions';
import { getDebouncedHandlerForTable, flushDebounceForTable } from './hooks/debounceHandler';

const Container = styled('div')`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

const IconContainer = styled('div')`
  height: 24px;
  width: 24px;
  border-radius: ${(props) => (props.square ? '4px' : '50%')};
  color: ${(props) => (props.color ? props.color : '#444444')};
  border: ${(props) => (props.square ? 'none' : 'solid 1px')};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${(props) => (props.square ? '8px' : '5px')};
  ${(props) => props.backgroundColor && `background: ${props.backgroundColor}`};
  ${(props) => props.square && 'padding: 4px'}; 
`;

const ProgressionTable = ({
  contentIndex,
  content,
  nonSwappedItemFromParentCalendar,
  date,
  dayNumber,
}) => {
  const [progressionSteps, setProgressionSteps] = useState([]);
  const [selectedProgression, setSelectedProgression] = useState({ id: content.step, name: `Step ${content.step}` });

  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  const effectiveDate = date || selectedDate;
  const combineWithInfo = useSelector((state) => state.calendar.data.combineWithInfo);
  const programType = useSelector((state) => state.calendar.data.programType);

  const dispatch = useDispatch();

  const debouncedHandleUpdateProgression = getDebouncedHandlerForTable(content.assignedId, (
    dbContent,
    dbSelectedProgression,
    dbNonSwappedItemFromParentCalendar,
    reorder = false,
  ) => {
    const updateItem = {
      assignedId: dbContent.assignedId,
      exerciseId: dbContent.exerciseId,
      date: programType === 'free-form-program' ? '' : moment(effectiveDate).format('YYYY-MM-DD'),
      order: contentIndex,
      description: dbContent?.exercise?.description || '',
      type: 'progression',
      step: dbSelectedProgression.id,
    };
    if (programType === 'free-form-program') {
      updateItem.dayNumber = dayNumber;
    }
    if (dbContent.groupingLetter) {
      updateItem.groupingLetter = dbContent.groupingLetter;
    }
    if (dbContent.groupingColorCode) {
      updateItem.groupingColorCode = dbContent.groupingColorCode;
    }
    if (programType === 'free-form-program') {
      dispatch(updateSavedWorkoutItem(currentUser.accountCode, updateItem, contentIndex, dayNumber, reorder));
    }
    if (programType === 'calendar') {
      if (dbNonSwappedItemFromParentCalendar) {
        dispatch(swapProgrammedItemOnChildCalendar(currentUser.accountCode, updateItem, contentIndex, moment(effectiveDate).format('YYYY-MM-DD'), reorder));
      } else {
        dispatch(updateProgrammedCalendarItem(currentUser.accountCode, updateItem, contentIndex, moment(effectiveDate).format('YYYY-MM-DD'), reorder));
      }
    }
  }, nonSwappedItemFromParentCalendar ? 0 : 4000);

  useEffect(() => {
    const isSource = combineWithInfo?.source?.length
      ? combineWithInfo.source.some((item) => item?.assignedId.toString() === content?.assignedId.toString())
      : false;

    const sourceItem = combineWithInfo?.source?.find(
      (item) => item?.assignedId.toString() === content?.assignedId.toString(),
    );

    const isTarget = combineWithInfo?.target?.assignedId === content?.assignedId;

    const targetItem = combineWithInfo?.target;

    if (!content.preSave && combineWithInfo && ((isSource) || (isTarget))) {
      dispatch(setCombineWithInfo(null));
      const updateItem = {
        ...content,
        groupingLetter: isSource
          ? sourceItem?.groupingLetter
          : isTarget
            ? targetItem?.groupingLetter
            : content?.groupingLetter,

        groupingColorCode: isSource
          ? sourceItem?.groupingColorCode
          : isTarget
            ? targetItem?.groupingColorCode
            : content?.groupingColorCode,
      };
      const reorder = true;
      debouncedHandleUpdateProgression(updateItem, selectedProgression, nonSwappedItemFromParentCalendar, reorder);
      flushDebounceForTable(content.assignedId);
    }
  }, [combineWithInfo]);

  useEffect(() => {
    const progressionStepsArray = [];
    for (let i = 0; i < parseInt(content.exercise?.levels, 10); i += 1) {
      const progressionStep = {
        id: i + 1,
        name: `Step ${i + 1}`,
        includeCheckmark: selectedProgression?.id === i + 1,
        checkmarkColor: '#BDBDBD',
      };
      progressionStepsArray.push(progressionStep);
    }

    setProgressionSteps(progressionStepsArray);
  }, [content, selectedProgression]);

  const setSelectedProgressionTrigger = (option) => {
    debouncedHandleUpdateProgression(content, option, nonSwappedItemFromParentCalendar);

    if (nonSwappedItemFromParentCalendar) {
      flushDebounceForTable(content.assignedId);
    }

    setSelectedProgression(option);
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderTopRightRadius: state.options.some((option) => option.id === 'sets') && '0px',
      borderBottomRightRadius: state.options.some((option) => option.id === 'sets') && '0px',
      fontFamily: 'Nunito Sans',
      fontSize: '16px',
      fontWeight: 400,
      background: '#FCFCFC',
      border: '1px solid #EEEEEE',
      height: '38px',
      minHeight: '38px',
      borderColor: state.isFocused ? '#EEEEEE' : '#EEEEEE',
      boxShadow: state.isFocused ? 'none' : 'none',
      '&:hover': {
        borderColor: state.isFocused ? '#EEEEEE' : '#EEEEEE',
      },
    }),
    container: (provided) => ({
      ...provided,
      width: '100%',
    }),
    option: (provided, state) => ({
      ...provided,
      paddingLeft: state.data.parentId ? 35 : 15,
      padding: '4px',
      backgroundColor: 'white',
      color: state.isSelected ? '#BDBDBD' : '#444444',
      fontFamily: 'Nunito Sans',
      fontSize: '16px',
      marginBottom: '8px',
      fontWeight: 400,
      '&:hover': {
        backgroundColor: '#FCFCFC',
      },
    }),
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: '#FCFCFC',
      border: '1px solid #EEEEEE',
      borderRadius: '4px',
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      color: '#444444',
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: '#9E9E9E',
    }),
    menu: (provided) => ({
      ...provided,
      border: '0px',
      minWidth: '250px',
      padding: '16px',
      marginTop: '0px',
      marginBottom: '0px',
      boxShadow: '0px 4px 8px 0px #3031331A',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '500px',
    }),
    group: (provided) => ({
      ...provided,
      padding: '0px',
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontSize: '16px',
      fontWeight: 700,
      color: '#9E9E9E',
      paddingLeft: '0px',
      paddingRight: '0px',
      marginBottom: '8px',
      fontFamily: 'Nunito Sans',
      textTransform: 'none',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#9E9E9E',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }),
    input: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? 'inherit' : provided.color, /** Use 'inherit' to maintain original color */
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: 'none',
    }),
  };

  const CustomOption = (props) => (
    <components.Option {...props}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: props.data.includeCheckmark ? 'space-between' : '' }}>
        <div style={{ display: 'flex' }}>
          {!props.data.avatar ? (
            <>
              {props?.data?.includeIconContainer ? (
                <IconContainer color={props.data.iconContainerColor} square={props.data?.squareContainer} backgroundColor={props.data?.backgroundColor}>
                  <IcomoonReact
                    iconSet={iconSet}
                    size={16}
                    icon={props.data.icon}
                    color={props.data.color || '#444444'}
                  />
                </IconContainer>
              ) : (
                <IcomoonReact
                  iconSet={iconSet}
                  size={16}
                  icon={props.data.icon}
                  color={props.data.color || '#444444'}
                  style={{ marginRight: 5 }}
                />
              )}
            </>
          ) : (
            <div style={{
              marginRight: 5,
            }}
            >
              {props.data.avatar}
            </div>
          )}
          {props.children}
        </div>
        {props.data.includeCheckmark && (
        <IcomoonReact
          iconSet={iconSet}
          size={12}
          icon='checkmark'
          color={props.data.checkmarkColor || '#444444'}
          style={{ marginRight: 5 }}
        />
        )}
      </div>
    </components.Option>
  );

  return (
    <Container>
      <Select
        value={selectedProgression}
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => option.id}
        options={progressionSteps}
        components={{
          Option: CustomOption,
        }}
        onChange={(option) => {
          setSelectedProgressionTrigger(option);
        }}
        isSearchable
        styles={customStyles}
        menuPortalTarget={document.body}
        menuPosition='fixed'
        menuShouldBlockScroll
        placeholder='Select step the athlete will be shown that corresponds to their level'
      />
    </Container>
  );
};

ProgressionTable.propTypes = {
  contentIndex: PropTypes.number.isRequired,
  content: PropTypes.instanceOf(Object).isRequired,
  nonSwappedItemFromParentCalendar: PropTypes.bool.isRequired,
  date: PropTypes.string,
  dayNumber: PropTypes.string,
};

ProgressionTable.defaultProps = {
  date: null,
  dayNumber: null,
};

export default ProgressionTable;
